export default "__VITE_ASSET__C_c0OS8O__"